import { getLegacyTimelineSummary } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTimelineSummaryGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreLegacyTimelineSummary',
	receive: true,
	request: true,
	requestHandler: getLegacyTimelineSummary,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
